import React from "react";
import {connect} from "react-redux";
import {cx} from "../../lib/ClassSet";
import CloseX from "../shared/icons/CloseX";
import "./CommandWindow.scss";

const CommandWindow = (props) => {

  let outerStyles = {
    zIndex: props.index
  }
  let innerStyles = {}
  if (props.options.height) {
    innerStyles.height = props.options.height;
  }
  if (props.width) {
    innerStyles.width = props.width;
  }

  let classes = cx({
    "CommandWindow": true,
    "s-active": props.active,
    "s-inactive": !props.active,
    "s-modal": props.modal,
    "s-headless": props.headless,
  });
  
  const cancelIcon = props.cancelType && (
    <CloseX color="var(--grey-800)"
      onClick={() => props.dispatch({ type: props.cancelType })}
    />
  );

  return (
    <div className="CommandWindowOuter" style={outerStyles}>
      <div className="u-spacer-top u-spacer" />
      <div className={classes} style={innerStyles}>
        <div className="header">
          <div className="title">{props.title}</div>
          { cancelIcon }
        </div>
        <div className="content">
          {props.children}
        </div>
      </div>
      <div className="u-spacer-bottom u-spacer" />
    </div>
  );

}

CommandWindow.defaultProps = {
  title: "Command Window",
  index: 0, // zIndex so we know how to stack em.
  active: true,
  modal: false,
  headless: false,
  options: {}
}

// We need to be able to dispatch the cancel type when available
export default connect()(CommandWindow);